//@ts-ignore
import { Veriff } from "@veriff/js-sdk";
import { VerifiedOutlined } from "@mui/icons-material";
import { MESSAGES, createVeriffFrame } from '@veriff/incontext-sdk';
import { useCallback } from "react";
import { setVerificationStatus } from "../Redux/slices/WebsocketSlice";
import { useAppDispatch, useAppSelector } from "../Redux/store";
import { VerificationStatus } from "../Types/General";
import { AppSettings } from "../Utils/Settings";
import { useUser } from "./useUser";

interface useVeriffProps {}
export const useVeriff = () => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { user, locator, type} = useUser();
    /* ******************** Variables ******************** */
    const verification_status = useAppSelector( state => state.Websocket.verification_status);
    const veriff = Veriff({
        host: AppSettings.Veriff.Host,
        apiKey: AppSettings.Veriff.ApiKey,
        parentId: 'veriff-root',
        onSession: function(err: any, response: any) {
            // received the response, verification can be started / triggered now
            console.error('Veriff error: ', err)
            console.log('Veriff response: ', response)
            // incontext sdk
            createVeriffFrame({
                url: response.verification.url,
                onEvent: (msg) => {
                    switch(msg) {
                        case MESSAGES.STARTED:
                            break;
                        case MESSAGES.FINISHED:
                            handleVerificationComplete();
                            break;
                        case MESSAGES.CANCELED:
                            break;
                    }
                }
            });
        }
    });
    /* ******************** Functions ******************** */
    const handleVerificationComplete = () => {
        dispatch(setVerificationStatus('pending'));
    }
    const mountVeriff = () => {
        if (user && locator) {
            veriff.setParams({
                person: {
                    givenName: user!.first_name,
                    lastName: user!.last_name
                },
                vendorData: locator
            })
            veriff.mount();
        }
    }
    const getVerificationDetails = useCallback(() => { 
        const status = verification_status ?? user?.verification_status;
        switch(status) {
            case VerificationStatus.unverified:
                return {
                    title: `Complete verification`,
                    subtitle: 'Complete your verification to gain access to the marketplace.',
                    veriff: true,
                }
            case VerificationStatus.pending:
                return {
                    title: `Under review`,
                    subtitle: 'Thank you for submitting a document for review, you will be notified as soon as the process is complete.',
                    veriff: false,
                }
            case VerificationStatus.denied:
                return {
                    title: `Verification Failed`,
                    icon: <VerifiedOutlined color="error"/>,
                    subtitle: 'Please submit a valid document for verification.',
                    veriff: true,
                }
            case VerificationStatus.verified:
                return {
                    title: `Verified`,
                    subtitle: 'Your verification is complete!',
                    veriff: false,
                }
            default:
                return {
                    title: ``,
                    subtitle: '',
                    veriff: false,
                }
        }
    }, [user, verification_status]);
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return {
        mountVeriff,
        getVerificationDetails
    }
}

